import Icon from '../components/Icon.vue'

Icon.register({
  'toggle-on': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M384 64c106 0 192 86 192 192s-86 192-192 192h-192c-106 0-192-86-192-192s86-192 192-192h192zM384 384c70.7 0 128-57.2 128-128 0-70.7-57.2-128-128-128-70.7 0-128 57.2-128 128 0 70.7 57.2 128 128 128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/toggle-on.js
// module id = 2016
// module chunks = 0